import React, { useState } from "react";
import { treatmentHistory } from "../../secondUtils/constants";
import { FaLongArrowAltRight } from "react-icons/fa";

const TreatmentHistory = (props) => {
    const [showBtn, setShowBtn] = useState(false)
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className="treatment-history-main">
            <div className="treatment-container"
                data-aos="fade-up"
                data-aos-easing="ease-out-bounce"
                data-aos-delay="300"
                data-aos-duration="2000">
                <h1>{selectedLanguage?.txt_dentistry_is_restoring}</h1>
                <div className="treatment-cards-main">
                    {
                        treatmentHistory?.map((v, i) => {
                            return (
                                <div>
                                    <h1>{v?.quantity}</h1>
                                    <h2>
                                        {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="treatment-btn-div">
                {!showBtn ? <button onMouseEnter={() => setShowBtn(true)}>{selectedLanguage?.txt_find_out_more}</button>
                    :
                    <button onMouseLeave={() => setShowBtn(false)} className="treatment-arrow-btn"><FaLongArrowAltRight /></button>}
            </div>
        </div>
    )
}

export default TreatmentHistory